// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"style__chartWrapper__dIE1G","heading":"style__heading__tS1-g","tooltip":"style__tooltip__L6gxL"};